import React, { useEffect } from "react";

/**
 * `/sprint` public redirect route.
 *
 * A `mexmagic.hu/sprint` (és a preview env `/sprint`) egyszerűen továbbküldi
 * a látogatót a Circle checkout URL-re. Ez client-side redirect
 * (`window.location.replace`), így a browser history-ből nem lehet vissza-
 * navigálni a `/sprint`-re véletlenül.
 *
 * A rövid „Átirányítás..." UI csak fallbackként jelenik meg addig, amíg a
 * browser el nem indítja a navigációt. A cél URL a v1-hez fixen bekötve.
 */
const CHECKOUT_URL = "https://mex.circle.so/checkout/mex-magic-sprint";

export default function SprintRedirect() {
  useEffect(() => {
    window.location.replace(CHECKOUT_URL);
  }, []);

  return (
    <div
      data-testid="sprint-redirect-page"
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "12px",
        padding: "24px",
        fontFamily: "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
        background: "#0a0a0a",
        color: "#fafafa",
        textAlign: "center",
      }}
    >
      <div style={{ fontSize: "15px", opacity: 0.8 }}>
        Átirányítás a MEX Magic Sprint jelentkezéshez...
      </div>
      <a
        href={CHECKOUT_URL}
        data-testid="sprint-checkout-link"
        style={{
          fontSize: "14px",
          color: "#e0b464",
          textDecoration: "underline",
          textUnderlineOffset: "3px",
        }}
      >
        Ha nem történik meg automatikusan, kattints ide.
      </a>
    </div>
  );
}
